/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Price_Launch_NoteInputs */

const es_landing_price_launch_note = /** @type {(inputs: Landing_Price_Launch_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La gestión cuesta normalmente 150€.`)
};

const gl_landing_price_launch_note = /** @type {(inputs: Landing_Price_Launch_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A xestión custa normalmente 150€.`)
};

const en_landing_price_launch_note = /** @type {(inputs: Landing_Price_Launch_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Management normally costs €150.`)
};

/**
* | output |
* | --- |
* | "Management normally costs €150." |
*
* @param {Landing_Price_Launch_NoteInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_price_launch_note = /** @type {((inputs?: Landing_Price_Launch_NoteInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Price_Launch_NoteInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_price_launch_note(inputs)
	if (locale === "en") return en_landing_price_launch_note(inputs)
	return es_landing_price_launch_note(inputs)
});